import {
  PettyCashReplenishmentStateTypes,
  PettyCashReplenishmentActionTypes,
} from "./PettyCashReplenishment.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: PettyCashReplenishmentStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const PettyCashReplenishmentReducer = (
  state: PettyCashReplenishmentStateTypes = INITIAL_STATE,
  action: any
): PettyCashReplenishmentStateTypes => {
  switch (action.type) {
    case PettyCashReplenishmentActionTypes.FETCH_ALL_PETTY_CASH_REPLENISHMENT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case PettyCashReplenishmentActionTypes.FETCH_ALL_PETTY_CASH_REPLENISHMENT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case PettyCashReplenishmentActionTypes.FETCH_ALL_PETTY_CASH_REPLENISHMENT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case PettyCashReplenishmentActionTypes.FETCH_ALL_PETTY_CASH_REPLENISHMENT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case PettyCashReplenishmentActionTypes.FETCH_ONE_PETTY_CASH_REPLENISHMENT:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case PettyCashReplenishmentActionTypes.FETCH_ONE_PETTY_CASH_REPLENISHMENT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case PettyCashReplenishmentActionTypes.FETCH_ONE_PETTY_CASH_REPLENISHMENT_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case PettyCashReplenishmentActionTypes.FETCH_ONE_PETTY_CASH_REPLENISHMENT_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default PettyCashReplenishmentReducer;
